import React from 'react';

import { Alert as NativeAlert, StyleSheet, Platform } from 'react-native';
import { Card, Text, View, Header, Content, Button, CardItem } from 'native-base';
import Modal from 'modal-enhanced-react-native-web';

class Alert extends React.Component {
	static alert(
		title = '',
		desc = '',
		buttons = [
			{
				text: 'Ok',
				onPress: () => {}
			}
		],
		options = { cancelable: false }
	) {
		if (Platform.OS == 'web') {
			Alert.alertInstance.setState({ settings: { title, desc, buttons, options } });
		} else NativeAlert.alert(title, desc, buttons, options);
	}
	static alertInstance = null;

	constructor(props) {
		super(props);

		//console.log(this.props.navigation.state);

		this.state = {
			settings: null
		};
	}

	componentDidMount() {
		Alert.alertInstance = this;
	}
	onSelect(f) {
		this.setState({ settings: null });
		f && f();
	}
	render() {
		const { settings } = this.state;
		//console.log(settings);
		return settings ? (
			<Modal
				//animationIn="slideInUp"
				//animationOut="slideOutDown"
				animationType="fade"
				backdropOpacity={0.5}
				isVisible={true}
				transparent={true}
				onBackdropPress={() => {
					settings.options && settings.options.cancelable && this.onSelect(false);
				}}
				presentationStyle="overFullScreen"
				animationType="slide"
				swipeDirection="down">
				<View style={styles.wrapper}>
					<Card>
						<CardItem header bordered>
							<Text>{settings.title}</Text>
						</CardItem>
						<CardItem bordered>
							<Text>{settings.desc}</Text>
						</CardItem>
						<CardItem bordered style={styles.cards}>
							{settings.buttons.map((button, i) => (
								<Button bordered={button.style == 'cancel'} disabled={button.disabled} key={i} onPress={() => this.onSelect(button.onPress)} style={styles.card}>
									<Text>{button.text}</Text>
								</Button>
							))}
						</CardItem>
					</Card>
				</View>
			</Modal>
		) : null;
	}
}

export default Alert;

const styles = StyleSheet.create({
	wrapper: {
		//position: 'absolute',
		width: '300',
		height: '200',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'transparent'
	},
	cards: {
		minWidth: 300,
		justifyContent: 'space-between'
	},
	card: {
		paddingLeft: 5,
		paddingRight: 5
	}
});
